import * as React from 'react';
import deepmerge from 'deepmerge';

import APIService from '../../../api/APIService';

import GBApp from '../../../app/GBApp';

import TSplashScreen from '../../common/TAppSplash';
import TAPIDialog from '../../common/TAPIDialog';
import TDialog from "../../common/TDialog";

import {
  callSuccessFn,
  cloneObj,
} from "../../GB/GBUtil";

import RCMain from './RCMain';
import * as rcc from "../NonVisual/RCConst"
import * as rcu from "../NonVisual/RCUtil";
import * as rcdu from "../NonVisual/RCDataUtil";

class RCApp extends GBApp {

    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    state = deepmerge(this.state, rcu.createAppState());
    
    componentDidMount() {

        this.setDefaults(() => {

            this.setState({

                pageID  : rcc.welcomeForm,
                loading : false,

            });

        });

    }    

    setDefaults = (successFn) => {

        let indicatorObjList = [];

        for (let i = 1; i <= rcc.numDefIndicators; i++) {

            indicatorObjList.push(
                rcu.createIndObj(
                    rcu.getDefIndName(i),
                    rcu.getDefIndMstID(i),
                    rcu.getDefTargPopCurrID(i),
                    rcu.getDefGroupCurrID(i),
                    rcu.getDefEstFreq(i),
                    rcu.getDefDesiredPrec(i),
                    rcu.getDefDesignEffect(i),
                )
            );

        }

        let targPopObjList = [];

        for (let i = 1; i <= rcc.numDefTargPops; i++) {

            targPopObjList.push(
                rcu.createTargPopObj(
                    rcu.getDefTargPopName(i),
                    rcu.getDefTargPopParamName(i),
                    rcu.getDefTargPopMstID(i),
                )
            );

        }

        let groupObjList = [];

        for (let i = 1; i <= rcc.numDefGroups; i++) {

            groupObjList.push(
                rcu.createGroupObj(
                    rcu.getDefGroupName(i),
                    rcu.getDefGroupMstID(i)
                )
            );

        }

        this.setState({

            [rcc.targPopObjList_AS_C]   : targPopObjList,
            [rcc.groupObjList_AS_C]     : groupObjList,
            [rcc.indicatorObjList_AS_C] : indicatorObjList,

        }, () => callSuccessFn(successFn));

    };

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    onSideBarArrowClick = (sideBarOpenBool, successFn) => {

        const state = this.state;

        let bool;

        if (typeof sideBarOpenBool === "undefined") {

            bool = !rcdu.getSideBarOpen_AS(state);

        }
        else {

            bool = sideBarOpenBool;

        }

        this.setState({

            [rcc.sideBarOpen_AS_C] : bool,

        }, () => callSuccessFn(successFn));

    };

    onQ1Answered = (q1AnswerByte, successFn) => {

        const state = this.state;
        let answer2Byte = rcdu.getAnswer2Byte_AS(state);

        if (q1AnswerByte !== rcdu.getAnswer1Byte_AS(state)) {

            if (q1AnswerByte === rcc.precisionQ1A) {

                answer2Byte = rcc.precisionAQ2A;

            }
            else {

                answer2Byte = rcc.numHouseholdsBQ2A;

            }
        }

        this.setState({

            [rcc.answer1Byte_AS_C] : q1AnswerByte,
            [rcc.answer2Byte_AS_C] : answer2Byte,

        }, () => callSuccessFn(successFn));

    };

    onQ2Answered = (q2AnswerByte, successFn) => {

        this.setState({

            [rcc.answer2Byte_AS_C] : q2AnswerByte,

        }, () => callSuccessFn(successFn));

    };

    onSelectedIndicatorChange = (indCurrID, successFn) => {

        this.setState({

            [rcc.selectedIndCurrID_AS_C] : indCurrID,

        }, () => callSuccessFn(successFn));

    };

    onIndicatorTargPopCurrIDChange = (indCurrID, targPopCurrID, successFn) => {

        let indicatorObjList = cloneObj(rcdu.getIndicatorObjList_AS(this.state));

        const du = rcdu;

        du.setIndTargPopCurrID(indCurrID, indicatorObjList, targPopCurrID);

        this.setState({

            [rcc.indicatorObjList_AS_C] : indicatorObjList,

        }, () => callSuccessFn(successFn));

    };

    /* Currently only applies to custom indicators */
    onIndicatorTargPopTypeChange = (indCurrID, targPopTypeByte, successFn) => {

        let indicatorObjList = cloneObj(rcdu.getIndicatorObjList_AS(this.state));

        const du = rcdu;

        du.setIndTargPopType(indCurrID, indicatorObjList, targPopTypeByte);

        this.setState({

            [rcc.indicatorObjList_AS_C] : indicatorObjList,

        }, () => callSuccessFn(successFn));

    };

    onTargPopParamValueChange = (indCurrID, paramCurrID, newParamValue, successFn) => {

        let indicatorObjList = cloneObj(rcdu.getIndicatorObjList_AS(this.state));

        rcdu.setIndParamValue(paramCurrID, indCurrID, indicatorObjList, newParamValue);

        this.setState({

            [rcc.indicatorObjList_AS_C] : indicatorObjList,

        }, () => callSuccessFn(successFn));

    };

    onTargPopCustomStrChange = (indCurrID, value, successFn) => {

        let indicatorObjList = cloneObj(rcdu.getIndicatorObjList_AS(this.state));

        rcdu.setIndTargPopCustomStr(indCurrID, indicatorObjList, value);

        this.setState({

            [rcc.indicatorObjList_AS_C] : indicatorObjList,

        }, () => callSuccessFn(successFn));

    };

    /* Prefer to use methods to change specific fields of specific indicators since it's safer, but this method can be
       used when you have an intermediate indicatorObjList that you only want to save if the user clicks ok. */
    onIndicatorObjListChange = (indicatorObjList, successFn) => {

        this.setState({

            [rcc.indicatorObjList_AS_C] : indicatorObjList,

        }, () => callSuccessFn(successFn));

    };

    onAnalyzeIndicatorChange = (indCurrID, analyzeBool, successFn) => {

        const state = this.state;
        let indicatorObjList = cloneObj(rcdu.getIndicatorObjList_AS(state));
        const selectedIndCurrID = rcdu.getSelectedIndCurrID_AS(state);

        if (indCurrID !== rcc.allIndicators) {

            rcdu.setIndAnalyzeBool(indCurrID, indicatorObjList, analyzeBool);

            /* If an indicator is activated for analysis, then... */
            if (analyzeBool) {

                /* If the selected indicator is currently 0, then we need to set the selected indicator to the
                   one that was just activated for analysis.*/
                if (selectedIndCurrID === 0) {

                    this.setState({

                        [rcc.indicatorObjList_AS_C] : indicatorObjList,

                    }, () => {

                        this.onSelectedIndicatorChange(indCurrID);

                    });

                }
                else {

                    this.setState({

                        [rcc.indicatorObjList_AS_C] : indicatorObjList,

                    }, () => callSuccessFn(successFn));

                }

            }
            /* Otherwise, an indicator was just deactivated. */
            else {

                /* If the deactivated indicator was the selected indicator, set the selected indicator to the first
                   available selected indicator or to 0 if no such indicator exists. */
                if (selectedIndCurrID === indCurrID) {

                    const indSelectedBool = rcdu.getAnyIndicatorSelected(indicatorObjList);

                    let newSelectedIndCurrID = 0;

                    if (indSelectedBool) {

                        newSelectedIndCurrID = rcdu.getFirstIndSelectedForAnalysis(indicatorObjList);

                    }

                    this.setState({

                        [rcc.indicatorObjList_AS_C] : indicatorObjList,

                    }, () => {

                        this.onSelectedIndicatorChange(newSelectedIndCurrID);

                    });

                }
                else {

                    this.setState({

                        [rcc.indicatorObjList_AS_C] : indicatorObjList,

                    }, () => callSuccessFn(successFn));

                }

            }

        }
        else {

            for (let i = 1; i <= indicatorObjList.length; i++) {

                rcdu.setIndAnalyzeBool(i, indicatorObjList, analyzeBool);

            }

            /* If all indicators were just activated for analysis, then... */
            if (analyzeBool) {

                /* If the selected indicator is currently 0, then we need to set the selected indicator to the
                   first one.*/
                if (selectedIndCurrID === 0) {

                    this.setState({

                        [rcc.indicatorObjList_AS_C] : indicatorObjList,

                    }, () => {

                        this.onSelectedIndicatorChange(1);

                    });

                }
                else {

                    this.setState({

                        [rcc.indicatorObjList_AS_C] : indicatorObjList,

                    }, () => callSuccessFn(successFn));

                }

            }
            /* Otherwise, all indicators were just deactivated. */
            else {

                this.setState({

                    [rcc.indicatorObjList_AS_C] : indicatorObjList,

                }, () => {

                    this.onSelectedIndicatorChange(0);

                });

            }

        }

    };

    onIndicatorNameChange = (indCurrID, name, successFn) => {

        let indicatorObjList = cloneObj(rcdu.getIndicatorObjList_AS(this.state));

        rcdu.setIndName(indCurrID, indicatorObjList, name);

        this.setState({

            [rcc.indicatorObjList_AS_C] : indicatorObjList,

        }, () => callSuccessFn(successFn));

    };

    onIndicatorGroupChange = (indCurrID, groupCurrID, successFn) => {

        let indicatorObjList = cloneObj(rcdu.getIndicatorObjList_AS(this.state));

        rcdu.setIndGroupCurrID(indCurrID, indicatorObjList, groupCurrID);

        this.setState({

            [rcc.indicatorObjList_AS_C] : indicatorObjList,

        }, () => callSuccessFn(successFn));

    };

    onIndicatorDataChange = (indCurrID, dataType, value, successFn) => {

        let indicatorObjList = cloneObj(rcdu.getIndicatorObjList_AS(this.state));

        switch (dataType) {

            case rcc.estFreqDataPr_PrHH :
                rcdu.setIndEstFreqPr(indCurrID, indicatorObjList, value);
                break;

            case rcc.desPrecDataPr_HH :
                rcdu.setIndDesiredPrecPr(indCurrID, indicatorObjList, value);
                break;

            case rcc.desEffectDataPr_PrHH :
                rcdu.setIndDesignEffectPr(indCurrID, indicatorObjList, value);
                break;

            case rcc.desNumHHsDataPr_Pr :
                rcdu.setIndDesiredNumHHsPr(indCurrID, indicatorObjList, value);
                break;

            case rcc.estBaseFreqDataPC_HHDf :
                rcdu.setEstFreqBaselinePC(indCurrID, indicatorObjList, value);
                break;

            case rcc.estEndFreqDataPC_HHDf :
                rcdu.setEstFreqEndlinePC(indCurrID, indicatorObjList, value);
                break;

            case rcc.designEffectDataPC_HHDf :
                rcdu.setIndDesignEffectPC(indCurrID, indicatorObjList, value);
                break;

            case rcc.desNumHHsPerSurveyDataPC_Df :
                rcdu.setDesNumHHsPerSurveyPC(indCurrID, indicatorObjList, value);
                break;

            default :
                break;

        }

        this.setState({

            [rcc.indicatorObjList_AS_C] : indicatorObjList,

        }, () => callSuccessFn(successFn));

    };

    onIndicatorParamLabChange = (indCurrID, paramLabType, value, successFn) => {

        let indicatorObjList = cloneObj(rcdu.getIndicatorObjList_AS(this.state));

        const endAge = rcdu.getIndTargPopLabEndAge(indCurrID, indicatorObjList);
        const startAge = rcdu.getIndTargPopLabStartAge(indCurrID, indicatorObjList);

        switch (paramLabType) {

            case rcc.startAgeLab :
                rcdu.setIndTargPopLabStartAge(indCurrID, indicatorObjList, value);

                if (endAge < startAge) {

                    rcdu.setIndTargPopLabEndAge(indCurrID, indicatorObjList, startAge);

                }

                break;

            case rcc.endAgeLab :
                rcdu.setIndTargPopLabEndAge(indCurrID, indicatorObjList, value);
                break;

            case rcc.refPeriodLab :
                rcdu.setIndTargPopLabRefPeriod(indCurrID, indicatorObjList, value);
                break;

            case rcc.genderLab :
                rcdu.setIndTargPopLabGender(indCurrID, indicatorObjList, value);
                break;

            default :
                break;

        }

        this.setState({

            [rcc.indicatorObjList_AS_C] : indicatorObjList,

        }, () => callSuccessFn(successFn));

    };

    onGroupNameChange = (groupCurrID, name, successFn) => {

        let groupObjList = cloneObj(rcdu.getGroupObjList_AS(this.state));

        rcdu.setGroupName(groupCurrID, groupObjList, name);

        this.setState({

            [rcc.groupObjList_AS_C] : groupObjList,

        }, () => callSuccessFn(successFn));

    };

    onAddGroup = (groupName, successFn) => {

        let groupObjList = cloneObj(rcdu.getGroupObjList_AS(this.state));

        let groupMstID = rcc.customGroupMinMstID;
        let stop = false;

        while (!stop) {

            let i = 1;
            let groupMstIDTaken = false;

            while ((i <= rcdu.getNumGroups(groupObjList)) && (!groupMstIDTaken)) {

                if (rcdu.getGroupMstID(i, groupObjList) === groupMstID) {

                    groupMstIDTaken = true;

                }

                i++;

            }

            if (groupMstIDTaken) {

                groupMstID++;

            }
            else {

                stop = true;

            }

        }

        rcdu.addGroup(groupName, groupMstID, groupObjList);

        this.setState({

            [rcc.groupObjList_AS_C] : groupObjList,

        }, () => callSuccessFn(successFn));

    };

    onDeleteGroup = (groupCurrID1DIntArray, successFn) => {

        let groupObjList = cloneObj(rcdu.getGroupObjList_AS(this.state));

        const numGroups = groupCurrID1DIntArray.length;
        for (let i = 1; i <= numGroups; i++) {

            const groupCurrID = groupCurrID1DIntArray.pop();
            groupObjList.splice(groupCurrID - 1, 1);

        }

        this.setState({

            [rcc.groupObjList_AS_C] : groupObjList,

        }, () => callSuccessFn(successFn));

    };

    onMoveGroup = (groupCurrID, direction, successFn) => {

        let groupObjList = cloneObj(rcdu.getGroupObjList_AS(this.state));

        let pos1 = groupCurrID - 1;
        let pos2;

        if ((direction === rcc.moveDown) && (rcdu.getNumGroups(groupObjList) > groupCurrID)) {

            pos2 = groupCurrID;

        }
        else if ((direction === rcc.moveUp) &&  (groupCurrID > 1)) {

            pos2 = groupCurrID - 2;

        }

        if (typeof pos2 !== "undefined") {

            let groupTemp = groupObjList[pos2];
            groupObjList[pos2] = groupObjList[pos1];
            groupObjList[pos1] = groupTemp;

        }

        this.setState({

            [rcc.groupObjList_AS_C] : groupObjList,

        }, () => callSuccessFn(successFn));

    };

    onGroupPanelExpandedChange = (groupCurrID, expanded, successFn) => {

        let groupObjList = cloneObj(rcdu.getGroupObjList_AS(this.state));

        if (groupCurrID === rcc.allGroups) {

            for (let g = 1; g <= rcdu.getNumGroups(groupObjList); g++) {

                rcdu.setGroupPanelExpanded(g, groupObjList, expanded);

            }

        }
        else {

            rcdu.setGroupPanelExpanded(groupCurrID, groupObjList, expanded);

        }

        this.setState({

            [rcc.groupObjList_AS_C] : groupObjList,

        }, () => callSuccessFn(successFn));

    };

    onPageChange = (pageIDByte, successFn) => {

        this.setState({

            pageID : pageIDByte,

        }, () => callSuccessFn(successFn));

    };

    onDrawerChange = (drawerID, successFn, errorFn) => {

        if ((typeof drawerID === 'undefined') || (drawerID === '')) {

            this.setState({

                [rcc.drawerID_AS_C]   : "",
                [rcc.drawerOpen_AS_C] : false,

            }, () => callSuccessFn(successFn));

        }
        else {

            this.setState({

                [rcc.drawerID_AS_C]   : drawerID,
                [rcc.drawerOpen_AS_C] : true,

            }, () => callSuccessFn(successFn));

        }

    };

    onLanguageChange = (language, successFn) => {

        /* Note that this code relies on local storage, which will have already been set at this
           point, and not on the "language" in state to work. */
        const state = this.state;
        const indicatorObjList = rcdu.getIndicatorObjList_AS(state);
        const groupObjList = rcdu.getGroupObjList_AS(state);
        const targPopObjList = rcdu.getTargPopObjList_AS(state);

        /* Default indicator names can't be changed. They are saved into the objects when the
           objects are first created, so we need to update them when the language changes. */
        for (let i = 1; i <= rcc.numDefIndicators; i++) {

            rcdu.setIndName(i, indicatorObjList, rcu.getDefIndName(i));

        }

        /* Group names are similar to default indicator names. */
        for (let g = 1; g <= rcc.numDefGroups; g++) {

            rcdu.setGroupName(g, groupObjList, rcu.getDefGroupName(g));

        }

        /* Target population is similar. */
        for (let tp = 1; tp <= rcc.numDefTargPops; tp++) {

            rcdu.setTargPopName(tp, targPopObjList, rcu.getDefTargPopName(tp));
            rcdu.setTargPopParamName(tp, targPopObjList, rcu.getDefTargPopParamName(tp));

        }

        this.setState({

            [rcc.language_AS_C] : language,

        }, () => callSuccessFn(successFn));

    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {

        /* State */
        const state = this.state;

        const mainComp =
            <RCMain
                apiTasks                             = {state.apiTasks}
                onAddTasks                           = {this.onAddTasks}

                appState                             = {state}
                onStateChange                        = {this.onStateChange}

                onDrawerChange                       = {this.onDrawerChange}
                onSideBarArrowClick                  = {this.onSideBarArrowClick}
                heartBeat                            = {state.heartBeat}
                onPackTableChange                    = {this.onPackTableChange}

                onLanguageChange                     = {this.onLanguageChange}
                onQ1Answered                         = {this.onQ1Answered}
                onQ2Answered                         = {this.onQ2Answered}
                onPageChange                         = {this.onPageChange}

                onTargPopParamValueChange            = {this.onTargPopParamValueChange}
                onTargPopCustomStrChange             = {this.onTargPopCustomStrChange}
                onSelectedIndicatorChange            = {this.onSelectedIndicatorChange}
                onAnalyzeIndicatorChange             = {this.onAnalyzeIndicatorChange}
                onIndicatorNameChange                = {this.onIndicatorNameChange}
                onGroupNameChange                    = {this.onGroupNameChange}
                onGroupPanelExpandedChange           = {this.onGroupPanelExpandedChange}
                onAddGroup                           = {this.onAddGroup}
                onDeleteGroup                        = {this.onDeleteGroup}
                onMoveGroup                          = {this.onMoveGroup}
                onIndicatorDataChange                = {this.onIndicatorDataChange}
                onIndicatorGroupChange               = {this.onIndicatorGroupChange}
                onIndicatorObjListChange             = {this.onIndicatorObjListChange}
                onIndicatorParamLabChange            = {this.onIndicatorParamLabChange}
                onIndicatorTargPopCurrIDChange       = {this.onIndicatorTargPopCurrIDChange}
                onIndicatorTargPopTypeChange         = {this.onIndicatorTargPopTypeChange}
        />;

        const APIServiceComp =
            <APIService
                apiTasks                = {state.apiTasks}
                appState                = {state}
                onIncrementCallsSent    = {this.onIncrementCallsSent}
                onIncrementCallsSuccess = {this.onIncrementCallsSuccess}
                onIncrementCallsError   = {this.onIncrementCallsError}
                onIncrementCallsFail    = {this.onIncrementCallsFail}
                onStateChange           = {this.onStateChange}
                onProjectionAdd         = {this.onProjectionAdd}
            />;

        const APIDialogComp =
            <TAPIDialog
                apiTasks = {state.apiTasks}
            />;

        const commWithServerDialog =
            <TDialog
                caption = {"Communicating with server..."}
                modal   = {true}
                visible = {false}//this.state.processingServerCall}
                style   = {{
                    width: '370px',
                }}
            />;

        if (state.loading) {

            return (

                <div>
                    <TSplashScreen />
                    {APIServiceComp}
                </div>

            );

        }
        else {

            return (

                <React.Fragment>
                    {mainComp}
                    {APIServiceComp}
                    {APIDialogComp}
                    {commWithServerDialog}
                </React.Fragment>

            );

        }

    }

}

export default RCApp;
